import { OptimisticMutationConfig, UpdateResolver } from "@urql/exchange-graphcache";
import {
    App,
    CreateIntentMutationVariables,
    GetIntentDocument,
    GetIntentsListDocument,
    GetIntentsListIntent,
    Intent,
    UpdateIntentMutationVariables
} from "generated/graphql";
import { updateTypeName } from "utils/graphql/data";

function updateIntent(cached: Intent, vars: UpdateIntentMutationVariables) {
    return Object.assign(cached, vars.intent);
}
export const intentUpdates: {
    [fieldName: string]: UpdateResolver;
} = {
    addIntent: (result: any, args, cache, info) => {
        const intent = result.addIntent as Intent;
        if (intent) {
            const vars = info.variables as CreateIntentMutationVariables;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetIntentsListDocument,
                variables: { appId }
            }, data => {
                const list = (data?.app as App)?.intents?.intents;
                if (list) {
                    list.push(updateTypeName(intent, "GetIntentsListIntent"));
                }

                return data;
            });
        }
    },
    updateIntent: (result: any, args, cache, info) => {
        if (result.updateIntent) {
            const vars = info.variables as UpdateIntentMutationVariables;
            const intentId = vars?.intentId;
            const appId = vars.appId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetIntentDocument,
                variables: { appId, intentId }
            }, data => {
                if (typeof data?.intent === "object") {
                    data.intent = updateIntent(data.intent as Intent, vars);
                }
                return data;
            });

            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetIntentsListDocument,
                variables: { appId }
            }, data => {
                const list = (data?.app as App)?.intents?.intents;
                if (list) {
                    const index = list.findIndex(i => i?.intentId === intentId);
                    if (index >= 0) {
                        list.splice(index, 1, updateTypeName(vars.intent, "GetIntentsListIntent") as GetIntentsListIntent);
                    }
                }

                return data;
            });
        }
    }

};

export const intentOptimistic: OptimisticMutationConfig = {
};
